import { Group, InputLabel, rem, Switch, useMantineTheme } from '@mantine/core';
import { GetInputPropsReturnType } from '@mantine/form/lib/types';
import { IconX, IconCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import StatusCell from '../../../../shared/ui/src/lib/status-cell/status-cell';

import classnames from './validation-status-switch.module.css';

import { FORM_STATUS } from '@data-access';

export function ValidationStatusSwitch(props: GetInputPropsReturnType) {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Group>
      <InputLabel htmlFor="status" size="md">
        {t('results.statusToForce')}
      </InputLabel>
      <StatusCell
        onClick={() => props.onChange(false)}
        status={FORM_STATUS.FINISHED}
      />
      <Switch
        classNames={{
          track: !props.checked ? classnames.switchTrack : undefined,
        }}
        color={'red'}
        id="status"
        labelPosition="left"
        size="md"
        thumbIcon={
          props.checked ? (
            <IconX
              color={theme.colors.red[6]}
              stroke={3}
              style={{ width: rem(12), height: rem(12) }}
            />
          ) : (
            <IconCheck
              color={theme.colors['pf-green'][6]}
              stroke={3}
              style={{ width: rem(12), height: rem(12) }}
            />
          )
        }
        {...props}
      ></Switch>
      <StatusCell
        onClick={() => props.onChange(true)}
        status={FORM_STATUS.REJECTED}
      />
    </Group>
  );
}

export default ValidationStatusSwitch;
